export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8917.12eb4b2f.jpg";